import React, { Component } from 'react'
import FacsimilePV from './FacsimilePV'
import AuthA from '../../store/actions/AuthA'

import {fetchData} from "../../utils/fetch-data"
import sortBy from 'lodash/sortBy'
import find from 'lodash/find'
import isEmpty from 'lodash/isEmpty'
import {connect} from 'react-redux'

const _ = {
  sortBy: sortBy,
  find: find,
  isEmpty: isEmpty
}

class FacsimilePC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sections: [],
      column: null,
      direction: null,
      sectionId: '',
      sectionStudents: [],
      schoolYears: [],
      schoolYearId: '',
      currentSchoolYear: null,
      loadingStudents: false
    };
    // this.getSection = this.getSection.bind(this);
    this.getSections = this.getSections.bind(this);
    this.getSectionStudents = this.getSectionStudents.bind(this);
    this.handleRowClick = this.handleRowClick.bind(this);
    this.handleSort = this.handleSort.bind(this);
  }

  getSchoolYears() {
    fetchData('/schoolyears?filter[where][active]=true')
    .then(response => {
      if(response) {
const currentSchoolYear = _.find(response.data, {
        isCurrent: true
      });
      this.setState({
        schoolYears: response.data,
        schoolYearId: currentSchoolYear.schoolYearId,
        currentSchoolYear: currentSchoolYear
      }, function(){
        this.getSections();
      });
      }
      
    });
  }

  getSections() {
    let url;
    if (this.props.userType === 'admin' || this.props.userType === 'principal' || this.props.userType === 'registrar') {
      url = '/sections?filter[where][active]=true&filter[where][schoolYearId]='+this.state.schoolYearId;
    } else if (this.props.userType === 'adviser' ) {
      url = '/sections?filter[where][active]=true&filter[where][teacherId]='+this.props.userId+'&filter[where][schoolYearId]='+this.state.schoolYearId;
    } else if (this.props.userType === 'levelHead' ){
      url = '/sections?filter[where][active]=true&filter[where][levelType][like]='+this.props.levelType+'&filter[where][schoolYearId]='+this.state.schoolYearId;
    } else {
      url = '/sections?filter[where][active]=true&filter[where][teacherId]='+this.props.userId+'&filter[where][schoolYearId]='+this.state.schoolYearId;
    }
    fetchData(url)
    .then(response => {

      if (!response || response.data.length === 0) {
        this.setState({loaded: false, sections: [], sectionId: '', loadingStudents: false})
      } else {
        this.setState({ sections: response.data, sectionId: response.data[0].sectionId, loaded: true, loadingStudents: true, sectionStudents: [] }, () => {
          setTimeout(() => {
            this.getSectionStudents(response.data[0].sectionId);
          }, 5000);
        });
      }

    });
  }

  // getSection() {
  //   fetchData('/sections?filter[where][teacherId]='+this.props.userId)
  //   .then(response => {
  //     console.log(response);
  //     this.setState({ section: response.data[0], sectionId: response.data[0].sectionId, loaded: true }, () => {
  //       this.getSectionStudents(response.data[0].sectionId);
  //     });
  //   });
  // }

  getSectionStudents(sectionId) {
    fetchData('/sectionStudents?filter[where][active]=true&filter[include]=student&filter[include]=grades&filter[include]=classConducts&filter[where][sectionId]='+sectionId)
    .then(response => {
      if(response) {
        const sorted = _.sortBy(response.data, function(o){return [o.student.lastName, o.student.firstName]})
        this.setState({ sectionStudents: sorted, loadingStudents: false });
      } else {
        this.setState({ loadingStudents: false });
      }

    });
  }

  handleRowClick(sectionId, studentId) {
    this.props.history.push(this.props.location.pathname+'/' + sectionId + '/' + studentId + '/' + this.state.schoolYearId);
  }

  handleSort(clickedColumn) {
    const { column, sectionStudents, direction } = this.state
    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        sectionStudents: _.sortBy(sectionStudents, [clickedColumn]),
        direction: 'ascending',
      })
      return
    }
    this.setState({
      sectionStudents: sectionStudents.reverse(),
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    })
  }

  handleChange = (e, { name, value }) => {
    if (name === 'sectionId') {
      // Clear students and show loading when section changes
      this.setState({sectionId: value, sectionStudents: [], loadingStudents: true}, () => {
        setTimeout(() => {
          this.getSectionStudents(value);
        }, 5000);
      });
    } else {
      this.setState({ [name]: value, loadingStudents: true }, () => this.getSections())
    }

  }

  componentDidMount() {
    this.props.authFn.getToken()
    this.props.onContentMount({title:'School Setup / Facsimile'});
    this.getSchoolYears();
    // if(this.props.match)
    // const sectionId = this.props.match.params.sectionId;
  }

  componentDidUpdate(prevProps) {
    // Only reload if userId or levelType changed
    if (prevProps.userId !== this.props.userId ||
        prevProps.levelType !== this.props.levelType ||
        prevProps.userType !== this.props.userType) {
      this.getSchoolYears();
    }
  }

  render() {
    return (
      <FacsimilePV
        auth={this.props.auth}
        userType={this.props.userType}
        column={this.state.column}
        direction={this.state.direction}
        sectionId={this.state.sectionId}
        sections={this.state.sections}
        sectionStudents={this.state.sectionStudents}
        schoolYearId={this.state.schoolYearId}
        schoolYears={this.state.schoolYears}
        currentSchoolYear={this.state.currentSchoolYear}
        loadingStudents={this.state.loadingStudents}
        handleSort={this.handleSort}
        handleChange={this.handleChange}
        handleRowClick={this.handleRowClick}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authFn: AuthA(dispatch)
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.AuthR.auth,
    userId: state.AuthR.userId,
    userType: state.AuthR.userType,
    levelType: state.AuthR.levelType,
    // Which period the Top Ten ranks on. SectionStudents used to re-derive this
    // from the month with its own boundaries and got it wrong.
    currentQuarter: state.QuarterR.currentQuarter
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FacsimilePC);
